import {
  AUTHENTICATE_USER, AUTHENTICATE_USER_SUCCEEDED, AUTHENTICATE_USER_FAILED,
  FETCH_SSO_URL, FETCHING_SSO_URL_SUCCEEDED, FETCHING_SSO_URL_FAILED, SSO_AUTHENTICATION_FAILED, INVALIDATE_SSO, SSO_AUTHENTICATION_SUCCESS
} from 'constants/actionTypes';
import _ from 'lodash';

const initialState = {
  authenticating: false,
  authenticated: false,
  authenticationError: null,
  me: null,
  sso: {
    loading: false,
    signinWithPassword: false,
    item: null,
  },
};

function loginReducer(state = initialState, action) {

  switch (action.type) {

    case AUTHENTICATE_USER:
      return Object.assign({}, state, {
        authenticating: true,
        authenticated: false,
        authenticationError: null,
      });

    case AUTHENTICATE_USER_SUCCEEDED:
      return Object.assign({}, state, {
        authenticating: false,
        authenticated: true,
        authenticationError: null
      });

    case AUTHENTICATE_USER_FAILED:
      var error = "Unable to authenticate. Please try again later";
      if (action.payload) {
        error = _.get(action.payload, 'error.errors[0].message', error);
      }
      return Object.assign({}, state, {
        authenticating: false,
        authenticated: false,
        authenticationError: error,
      });

    case FETCH_SSO_URL:
      return Object.assign({}, state, {
        ...state,
        sso: {
          ...state.sso,
          loading: true,
          signinWithPassword: false,
          item: null
        }
      })

    case FETCHING_SSO_URL_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        sso: {
          ...state.sso,
          loading: false,
          signinWithPassword: false,
          item: action.payload.response
        }
      })

    case FETCHING_SSO_URL_FAILED:
      return Object.assign({}, state, {
        ...state,
        sso: {
          ...state.sso,
          loading: false,
          signinWithPassword: true,
          item: null,
          error: action.payload.error
        }
      })

    case SSO_AUTHENTICATION_FAILED:
      return Object.assign({}, state, {
        ...state,
        sso: {
          ...state.sso,
          loading: false,
          item: null,
          signinWithPassword: true,
          error: {
            errors: [{
              code: 99999,
              message: action.payload.reason
            }]
          }
        }
      })

    case SSO_AUTHENTICATION_SUCCESS:
      return Object.assign({}, state, {
        authenticating: false,
        authenticated: true,
        authenticationError: null
      });
      
    case INVALIDATE_SSO:
      return {
        ...state,
        authentication: {
          ...state.authentication,
          error: null
        },
        sso: {
          ...state.sso,
          loading: false,
          signinWithPassword: false,
          item: null,
          error: null
        }
      }

    default:
      return state;

  }
}

export { loginReducer };